<template>
  <div class="text-h5" style="margin-bottom: 44px;">
    Новый шаблон
  </div>
  <div class="row">
    <div class="col-7 q-ma-lg">
      <div class="text-h5">
        Информация о документе
      </div>
      <div>
        <q-input v-model="name" hint="Уникальное поле" label="Название документа" />
      </div>
      <div>
        <q-select v-model="document_type" :options="document_type_options" label="Тип документа" />
      </div>
      <div>
        <q-input v-model="document_id" hint="Без пробелов, уникальное поле" label="Идентификатор документа" />
      </div>
    </div>

    <div class="col-12 q-ma-lg">
        <div class="text-h5">
          Верхняя часть документа
        </div>
        <q-list padding class="rounded-borders">
          <q-item v-for="item in top_section" v-bind:key="item.id">
            <q-item-section>
              <q-input v-model="item.name" hint="Указывается в описании поля" label="Название поля" />
            </q-item-section>
            <q-item-section>
              <q-input v-model="item.field_id" hint="Без пробелов, уникальное поле" label="Идентификатор поля" />
            </q-item-section>
            <q-item-section>
              <q-toggle v-model="item.analytic_filter" label="Фильтр для аналитики"/>
            </q-item-section>
            <q-item-section>
              <q-input v-model="item.order" label="Порядок" type="number"/>
            </q-item-section>
            <q-item-section>
              <q-select :options="column_type_options" v-model="item.content_type" label="Тип контента"/>
            </q-item-section>
            <q-item-section side>
              <q-btn @click="deleteTopSectionItem(item.id)" icon="delete" dense flat round color="red"/>
            </q-item-section>
          </q-item>
        </q-list>
        <q-btn icon="add" flat label="Добавить поле" @click="addFieldToTopSection"/>
    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Секция таблицы
      </div>
      <q-list v-for="section in table_section" v-bind:key="section.id" padding class="rounded-borders">
        <q-separator spaced />
        <q-item-label header>Группа колонок</q-item-label>
        <q-item>
          <q-item-section>
            <q-input v-model="section.name" hint="Первый ряд шапки таблицы" label="Название группы" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="section.group_id" hint="Без пробелов, уникальное поле" label="Идентификатор группы" />
          </q-item-section>
          <q-item-section>
            <q-toggle v-model="section.show_title" label="Показывать заголовок"/>
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.order" label="Порядок" type="number"/>
          </q-item-section>
        </q-item>
        <q-separator spaced />
        <q-item-label header>Колонки таблицы в группе</q-item-label>
        <q-item v-for="item in section.columns" v-bind:key="item.id">
          <q-item-section>
            <q-input v-model="item.column_name" hint="Заголовок столбца" label="Название колонки" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.column_id" hint="Без пробелов, уникальное поле" label="Идентификатор колонки" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.default_value" hint="" label="Значение по умолчанию" />
          </q-item-section>
          <q-item-section>
            <q-toggle v-model="item.analytic_filter" label="Фильтр для аналитики"/>
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.order" label="Порядок" type="number"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="size_options" v-model="item.size" label="Размер колонки"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="align_options" v-model="item.align" label="Выравнивание колонки"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="column_type_options" v-model="item.content_type" label="Тип контента"/>
          </q-item-section>
          <q-item-section side>
            <q-btn @click="deleteColumn(section.id, item.id)" icon="delete" dense flat round color="red"/>
          </q-item-section>
        </q-item>
        <q-item>
          <q-item-section>
            <q-btn icon="add" flat label="Добавить колонку" @click="addColumnToTableSection(section.id)"/>
          </q-item-section>
        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить группу полей" @click="addGroupToTableSection"/>

    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Нижняя часть документа
      </div>
      <q-list padding class="rounded-borders">
        <q-item v-for="item in bottom_section" v-bind:key="item.id">
          <q-item-section>
            <q-input v-model="item.name" hint="Указывается в описании поля" label="Название поля" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.field_id" hint="Без пробелов, уникальное поле" label="Идентификатор поля" />
          </q-item-section>
          <q-item-section>
            <q-toggle v-model="item.analytic_filter" label="Фильтр для аналитики"/>
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.order" label="Порядок" type="number"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="column_type_options" v-model="item.content_type" label="Тип контента"/>
          </q-item-section>
          <q-item-section side>
            <q-btn @click="deleteBottomSectionItem(item.id)" icon="delete" dense flat round color="red"/>
          </q-item-section>
        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить группу полей" @click="addFieldToBottomSection"/>
    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Нижняя левая часть документа
      </div>
      <q-list padding class="rounded-borders">
        <q-item v-for="item in bottom_section_left" v-bind:key="item.id">
          <q-item-section>
            <q-input v-model="item.name" hint="Указывается в описании поля" label="Название поля" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.field_id" hint="Без пробелов, уникальное поле" label="Идентификатор поля" />
          </q-item-section>
          <q-item-section>
            <q-toggle v-model="item.analytic_filter" label="Фильтр для аналитики"/>
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.order" label="Порядок" type="number"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="column_type_options" v-model="item.content_type" label="Тип контента"/>
          </q-item-section>
          <q-item-section side>
            <q-btn @click="deleteBottomLeftSectionItem(item.id)" icon="delete" dense flat round color="red"/>
          </q-item-section>

        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить группу полей" @click="addFieldToBottomLeftSection"/>
    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Нижняя правая часть документа
      </div>
      <q-list padding class="rounded-borders">
        <q-item v-for="item in bottom_section_right" v-bind:key="item.id">
          <q-item-section>
            <q-input v-model="item.name" hint="Указывается в описании поля" label="Название поля" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.field_id" hint="Без пробелов, уникальное поле" label="Идентификатор поля" />
          </q-item-section>
          <q-item-section>
            <q-toggle v-model="item.analytic_filter" label="Фильтр для аналитики"/>
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.order" label="Порядок" type="number"/>
          </q-item-section>
          <q-item-section>
            <q-select :options="column_type_options" v-model="item.content_type" label="Тип контента"/>
          </q-item-section>
          <q-item-section side>
            <q-btn @click="deleteBottomRightSectionItem(item.id)" icon="delete" dense flat round color="red"/>
          </q-item-section>

        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить группу полей" @click="addFieldToBottomRightSection"/>
    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Позиции по документу
      </div>
      <q-list padding class="rounded-borders">
        <q-item>
          <q-item-section>
            <q-toggle v-model="has_positions" label="Создавать позиции из документа" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_code_id" label="Поле: код позиции" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_name_id" label="Поле: название позиции" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_price_id" label="Поле: цена позиции" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_nds_id" label="Поле: НДС позиции" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_acis_id" label="Поле: акциз позиции" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="position_count_id" label="Поле: количество позиции" />
          </q-item-section>

        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить группу полей" @click="addFieldToBottomSection"/>
    </div>

    <div class="col-12 q-ma-lg">
      <div class="text-h5">
        Проводки по документу
      </div>
      <q-list padding class="rounded-borders">
        <q-item>
          <q-item-section>
            <q-toggle v-model="has_transfers" label="Создавать проводки из документа" />
          </q-item-section>
        </q-item>
      </q-list>
      <q-list v-show="has_transfers" padding class="rounded-borders">
        <q-item v-for="item in transfers_list" v-bind:key="item.id">
          <q-item-section>
            <q-input v-model="item.name" label="Название" />
          </q-item-section>
          <q-item-section>
            <q-select v-model="item.bill_from" :options="bills_list" label="Счет списания" />
          </q-item-section>
          <q-item-section>
            <q-select v-model="item.bill_to" :options="bills_list" label="Счет зачисления" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.comment" label="Комментарий" />
          </q-item-section>
          <q-item-section>
            <q-input v-model="item.summ_field_id" label="Поле суммы" />
          </q-item-section>
        </q-item>
      </q-list>

      <q-btn icon="add" flat label="Добавить шаблон проводки" @click="addItemToTransferList"/>
    </div>

    <div class="col-7 q-ma-lg">
      <q-btn icon="save" flat label="Сохранить" @click="saveTemplate"/>
    </div>
  </div>
</template>

<script>

import {ref} from "vue";
import axios from "axios";
import {apiUrl} from "@/config";

const base_template = {
  name: 'Новый документ',
  document_id: 'new_document',
  top_section: [
    {
      id: 0,
      name: "Заголовок документа",
      field_id: "document_title",
      analytic_filter: false,
      order: 0,
      content_type: ''
    },
  ],
  table_section: [
    {
      id: 0,
      name: "Группа полей",
      group_id: "fileds_group",
      show_title: false,
      order: 0,
      columns: [
        {
          id: 0,
          column_name: "Название колонки",
          column_id: "column_id",
          analytic_filter: false,
          size: '',
          align: '',
          content_type: 'simple',
          order: 0,
          default_value: ''
        }
      ]
    }
  ],
  bottom_section: [
    {
      id: 0,
      name: "Директор",
      field_id: "director",
      analytic_filter: false,
      order: 0,
      content_type: 'simple'
    },
  ],
  bottom_section_left: [
    {
      id: 0,
      name: "Директор",
      field_id: "director",
      analytic_filter: false,
      order: 0,
      content_type: 'simple'
    },
  ],
  bottom_section_right: [
    {
      id: 0,
      order: 0,
      name: "Директор",
      field_id: "director",
      analytic_filter: false,
      content_type: 'simple'
    },
  ]
}

const column_type_options = [
  {
    label: 'Обычное',
    value: 'simple'
  },
  {
    label: 'Количество',
    value: 'count'
  },
  {
    label: 'Сумма без налогов',
    value: 'total_price_without_tax'
  },
  {
    label: 'Сумма с налогами',
    value: 'total_price_with_tax'
  },
  {
    label: 'Цена за единицу',
    value: 'cost'
  },
  {
    label: 'НДС',
    value: 'nds'
  },
  {
    label: 'Ставка НДС',
    value: 'nds_percentage'
  },
  {
    label: 'Название',
    value: 'name'
  },
  {
    label: 'Единица измерения',
    value: 'count_name'
  },
  {
    label: 'Контрагент',
    value: 'contragent'
  },
  {
    label: 'Сотрудник',
    value: 'user'
  },
  {
    label: 'Отдел',
    value: 'department'
  },
  {
    label: 'Ссылка на документ',
    value: 'document'
  },
  {
    label: 'Код товара',
    value: 'item_code'
  },
  {
    label: 'Акциз',
    value: 'acis_summ'
  },
  {
    label: 'Страна',
    value: 'country'
  },
]

const document_type_options = [
  {
    label: 'Документ',
    value: 'document'
  },
  {
    label: 'Отчет',
    value: 'report'
  },
  {
    label: 'Платежный документ',
    value: 'payment'
  }
]

const align_options = [
  {
    label: 'По левому краю',
    value: 'left',
  },
  {
    label: 'По центру',
    value: 'center',
  },
  {
    label: 'По правому краю',
    value: 'right',
  },
]
const size_options = [
  {
    label: '0.5x',
    value: '0.5',
  },
  {
    label: '1x',
    value: '1',
  },
  {
    label: '1.5x',
    value: '1.5',
  },
  {
    label: '2x',
    value: '2',
  },
  {
    label: '2.5x',
    value: '2.5',
  },
  {
    label: '3x',
    value: '3',
  },
]

export default {
  name: "template_edit",
  data() {
    if (this.$route.params.id) {
      const data = {
        id: this.$route.params.id
      }
      axios
          .post(apiUrl + '/admin/documents/info/', data, {auth: this.$store.state.credentials})
          .then((response) => {
            const data = response.data;
            this.name = data.name;
            this.document_type = data.document_type;
            this.document_id = data.document_id;
            this.top_section = data.structure.top_section;
            this.table_section = data.structure.table_section;
            this.bottom_section = data.structure.bottom_section;
            this.bottom_section_left = data.structure.bottom_section_left;
            this.bottom_section_right = data.structure.bottom_section_right;
            this.has_positions = data.positions.has_positions;
            this.position_code_id = data.positions.position_code_id;
            this.position_name_id = data.positions.position_name_id;
            this.position_price_id = data.positions.position_price_id;
            this.position_nds_id = data.positions.position_nds_id;
            this.position_acis_id = data.positions.position_acis_id;
            this.position_count_id = data.positions.position_count_id;
            this.transfers_list = data.transfers;
          });
    }
    this.emitter.on('onReceiveBillsList', (data) => {
      console.log(data.items);
      this.bills_list = data.items.map(function (x) { return {value: x.id, label: x.display_name} } );
    })
    axios
        .post(apiUrl + '/admin/bills/list/', {}, {auth: this.$store.state.credentials})
        .then((response) => {
          this.emitter.emit('onReceiveBillsList', response.data);
        })
    return {
      name: ref(base_template.name),
      document_id: ref(base_template.document_id),
      top_section: ref(base_template.top_section),
      table_section: ref(base_template.table_section),
      bottom_section: ref(base_template.bottom_section),
      bottom_section_left: ref(base_template.bottom_section_left),
      bottom_section_right: ref(base_template.bottom_section_right),
      bills_list: ref([]),
      align_options: align_options,
      size_options: size_options,
      column_type_options: column_type_options,
      document_type: ref(null),
      document_type_options: document_type_options,
      has_positions: ref(false),
      position_code_id: ref(null),
      position_name_id: ref(null),
      position_price_id: ref(null),
      position_nds_id: ref(null),
      position_acis_id: ref(null),
      position_count_id: ref(null),
      transfers_list: ref([]),
      has_transfers: ref(false)
    }
  },
  methods: {
    addFieldToTopSection() {
      this.top_section.push({
        id: this.top_section.length,
        name: "Новое поле",
        field_id: "",
        analytic_filter: false,
        order: 0,
        content_type: ''
      })
    },
    addFieldToBottomLeftSection() {
      this.bottom_section_left.push({
        id: this.bottom_section_left.length,
        name: "Новое поле",
        field_id: "",
        analytic_filter: false,
        order: 0,
        content_type: ''
      })
    },
    addFieldToBottomRightSection() {
      this.bottom_section_right.push({
        id: this.bottom_section_right.length,
        name: "Новое поле",
        field_id: "",
        analytic_filter: false,
        order: 0,
        content_type: ''
      })
    },
    addFieldToBottomSection() {
      this.bottom_section.push({
        id: this.bottom_section.length,
        name: "Новое поле",
        field_id: "",
        analytic_filter: false,
        order: 0,
        content_type: ''
      })
    },
    addGroupToTableSection() {
      this.table_section.push({
        id: this.table_section.length,
        name: "Группа полей",
        group_id: "fileds_group",
        show_title: false,
        order: 0,
        columns: [
          {
            id: 0,
            column_name: "Название колонки",
            column_id: "column_id",
            analytic_filter: false,
            order: 0,
            content_type: '',
            default_value: '',
          }
        ]
      })
    },
    addColumnToTableSection(group_id) {
      const group_index = this.table_section.findIndex( (element) => {
        return element.id === group_id
      });
      this.table_section[group_index].columns.push(
          {
            id: this.table_section[group_index].columns.length,
            column_name: "Название колонки",
            column_id: "column_id",
            order: 0,
            default_value: '',
            content_type: '',
            analytic_filter: false
          }
      )
    },
    deleteColumn(group_id, column_id) {
      const group_index = this.table_section.findIndex( (element) => {
        return element.id === group_id
      });
      this.table_section[group_index].columns = this.table_section[group_index].columns.filter((element) => {
        element.id === column_id
      })
    },
    deleteTopSectionItem(field_id) {
      this.top_section = this.top_section.filter((element) => { element.id === field_id });
    },
    deleteBottomSectionItem(field_id) {
      this.bottom_section = this.bottom_section.filter((element) => { element.id === field_id });
    },
    deleteBottomLeftSectionItem(field_id) {
      this.bottom_section_left = this.bottom_section_left.filter((element) => { element.id === field_id });
    },
    deleteBottomRightSectionItem(field_id) {
      this.bottom_section_right = this.bottom_section_right.filter((element) => { element.id === field_id });
    },
    addItemToTransferList() {
      this.transfers_list.push(
          {
            id: this.transfers_list.length,
            name: '',
            bill_from: this.bills_list[0],
            bill_to:this.bills_list[1],
            comment: '',
            summ_field_id: ''
          }
      )
    },
    saveTemplate() {

      var data = {
        name: this.name,
        document_id: this.document_id,
        document_type: this.document_type,
        structure:{
          top_section: this.top_section,
          table_section: this.table_section,
          bottom_section_left: this.bottom_section_left,
          bottom_section_right: this.bottom_section_right
        },
        positions: {
          has_positions: this.has_positions,
          position_code_id: this.position_code_id,
          position_name_id: this.position_name_id,
          position_price_id: this.position_price_id,
          position_nds_id: this.position_nds_id,
          position_acis_id: this.position_acis_id,
          position_count_id: this.position_count_id
        },
        transfers: this.transfers_list
      }
      if (this.$route.params.id) {
        data.id = this.$route.params.id;
      }
      axios
          .post(apiUrl + '/admin/documents/create/', data, {auth: this.$store.state.credentials})
          .then((response) => {
            console.log(response)
            this.$router.push({name: 'documents_list', params: {}})
          })
    }
  }
}
</script>

<style scoped>

</style>